import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cerrado',
  templateUrl: './cerrado.component.html',
  styleUrls: ['./cerrado.component.scss'],
})
export class CerradoComponent {
  public isOpen: boolean = true;

  public cerrar() {
    this.isOpen = false;
  }
}
